import React, { useState, useCallback, useEffect } from 'react';
import { supabase } from '../../../supabaseClient';

const AuditLogPanel = () => {
    const [auditLogs, setAuditLogs] = useState([]);
    const [loading,   setLoading]   = useState(false);

    const loadAuditLogs = useCallback(async () => {
        setLoading(true);
        const { data, error } = await supabase
            .from('admin_audit_log')
            .select('*, admin:profiles(name, email)')
            .order('created_at', { ascending: false });
        if (!error) setAuditLogs(data || []);
        setLoading(false);
    }, []);

    useEffect(() => { loadAuditLogs(); }, [loadAuditLogs]);

    return (
        <div className="space-y-4">
            <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Admin Audit Log</h2>

            {loading ? (
                <p className="text-gray-500 dark:text-gray-400 text-center py-8">Loading…</p>
            ) : auditLogs.length === 0 ? (
                <p className="text-gray-500 dark:text-gray-400 text-center py-8">No audit entries found</p>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg">
                        <thead className="bg-gray-100 dark:bg-gray-700 border-b dark:border-gray-600">
                            <tr>
                                {['Timestamp', 'Admin', 'Action', 'Details'].map(h => (
                                    <th key={h} className="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-gray-300">
                                        {h}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {auditLogs.map(log => (
                                <tr key={log.id} className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                    <td className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300 whitespace-nowrap">
                                        {new Date(log.created_at).toLocaleString()}
                                    </td>
                                    <td className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300">
                                        {log.admin?.name || 'Unknown'}<br />
                                        <span className="text-xs text-gray-500 dark:text-gray-400">{log.admin?.email}</span>
                                    </td>
                                    <td className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300">{log.action}</td>
                                    <td className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300">
                                        <pre className="bg-gray-100 dark:bg-gray-900 dark:text-gray-300 p-2 rounded text-xs overflow-x-auto">
                                            {JSON.stringify(log.details, null, 2)}
                                        </pre>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AuditLogPanel;